import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { AutoSectionView } from './AutoSectionView';

export const SECTION_TYPES = [
  { value: 'open-tasks', label: 'Open Tasks', description: 'Carry-forward tasks from previous meetings' },
  { value: 'attendees', label: 'Attendees', description: 'Default attendees for this series' },
  { value: 'action-items', label: 'Action Items', description: 'Empty task list ready to fill' },
  { value: 'recent-notes', label: 'Recent Notes', description: 'Links to recent meeting notes' },
] as const;

export type SectionType = (typeof SECTION_TYPES)[number]['value'];

export const AutoSection = Node.create({
  name: 'autoSection',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      sectionType: {
        default: 'action-items',
        parseHTML: (element) => element.getAttribute('data-section-type'),
        renderHTML: (attributes) => ({
          'data-section-type': attributes.sectionType,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="autoSection"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(
        { 'data-type': 'autoSection', class: 'auto-section-node' },
        HTMLAttributes,
      ),
      `[Auto: ${HTMLAttributes['data-section-type']}]`,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(AutoSectionView, {
      className: 'auto-section-nodeview-wrapper',
    });
  },
});
